import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=7cc1166e&"
import script from "./LeaderBoard.vue?vue&type=script&lang=js&"
export * from "./LeaderBoard.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoard.vue?vue&type=style&index=0&id=7cc1166e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports